import Image from "next/image";
import { useEffect, useState } from "react";
import { fetchUniversityGalleryByCountry } from "../common/GetGalleryArray";
import Back from "../common/Back";
interface BannerProps {
  country: string | null;
}

const Banner: React.FC<BannerProps> = ({ country }) => {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [transitioning, setTransitioning] = useState(false);
  const [universityLogos, setUniversityLogos] = useState<string[]>([]);

  useEffect(() => {
    if (country) {
      fetchUniversityGalleryByCountry(country, setUniversityLogos);
    }
  }, [country]);

  useEffect(() => {
    if (universityLogos.length > 1) {
      const interval = setInterval(() => {
        setCurrentImageIndex(currentImageIndex);
        setTransitioning(true);

        setTimeout(() => {
          setCurrentImageIndex((prevIndex) =>
            prevIndex === universityLogos.length - 1 ? 0 : prevIndex + 1,
          );

          setTimeout(() => {
            setTransitioning(false);
          }, 100);
        }, 200);
      }, 3000);
      return () => clearInterval(interval);
    }
  }, [currentImageIndex, universityLogos, universityLogos.length]);

  return (
    <div className="relative">
      <span className="absolute left-5 sm:left-10 top-[75px] sm:top-[85px] rounded-xl py-2 xl:py-0 px-2 bg-white/80 z-10 hover:bg-white duration-300 ease-in-out">
        <Back />
      </span>
      <div className="h-full relative">
        <Image
          className="sm:hidden h-full w-full max-h-[154px] absolute bottom-[-4px] left-0 pointer-events-none"
          src={"/assets/images/png/bannerWaveMobile.png"}
          alt="banner image"
          width={1024}
          height={860}
        />
        <Image
          className="hidden sm:block lg:hidden h-full w-full max-h-[220px] absolute bottom-[-4px] left-0 pointer-events-none"
          src={"/assets/images/png/bannerWaveTab.png"}
          alt="banner image"
          width={1024}
          height={860}
        />
        <Image
          className="hidden lg:block h-full w-full max-h-[300px] 2xl:max-h-[490px] absolute bottom-[-4px] left-0 pointer-events-none"
          src={"/assets/images/png/bannerWave.png"}
          alt="banner image"
          width={1920}
          height={860}
        />
        <Image
          className="h-[300px] sm:h-full w-full object-cover"
          src={`https://storage.googleapis.com/edvia_public_bucket/universities1/${country
            ?.replace("Europe -", "")
            .trim()
            .toLowerCase()
            .replace(/\s+/g, "_")
            .replace(
              "united_states_of_america",
              "united_states",
            )}/background.webp`}
          alt="banner image"
          width={1920}
          height={860}
        />
      </div>
      <div className="container 2xl:max-w-[1628px]  relative h-full mt-[-80px] sm:mt-[-100px] xl:mt-[-130px] 2xl:mt-[-200px] 3xl:mt-[-200px]">
        <div
          className={`size-[100px] sm:size-[160px] lg:size-[220px] xl:size-[300px] 3xl:size-[350px] rounded-full right-3 sm:right-24 3xl:right-0 bottom-[30%] lg:bottom-[10%] absolute object-cover bg-white duration-300 ease-in-out ${
            transitioning ? "opacity-0" : "opacity-100"
          }`}
        >
          <Image
            className="w-full h-full object-cover rounded-full outline-[4px] outline-white"
            src={universityLogos[currentImageIndex] || ""}
            alt={`UK university logo ${currentImageIndex + 1}`}
            width={300}
            height={300}
          />
        </div>
        <h1 className="font-bold text-[20px] sm:text-2xl lg:text-[28px] 2xl:text-[34px] xl:leading-[80px] max-w-[230px] sm:max-w-[290px] md:max-w-[300px] lg:max-w-full ">
          Top Universities in <span className="capitalize">{country}</span>
        </h1>
      </div>
    </div>
  );
};

export default Banner;
